<template>
	<section class="weekly-recommend">
		<h2 class="weekly-recommend__title">{{ title }}</h2>
		<div class="weekly-recommend__groups">
			<article
				v-for="(group, groupIndex) in weeklyRecommendGroups"
				:key="`weekly-group-${groupIndex}`"
				class="weekly-recommend__group"
			>
				<div
					v-for="(item, itemIndex) in group"
					:key="item.id"
					class="weekly-recommend__item"
					:class="{
						'weekly-recommend__item--cover': itemIndex === 0,
						'weekly-recommend__item--text': itemIndex !== 0,
					}"
					@click="toWeeklyRecommend(item.jump_url)"
				>
					<van-image
						v-if="itemIndex === 0"
						class="weekly-recommend__cover"
						:src="item.cover_cc || item.cover"
						:alt="item.name"
					/>
					<template v-else>
						<span class="weekly-recommend__name">{{ item.name }}</span>
						<span class="weekly-recommend__arrow">&gt;</span>
					</template>
				</div>
			</article>
		</div>
	</section>
</template>

<script setup>
import { computed } from "vue";
import { goLink } from "~/utils/common";

const props = defineProps({
	data: {
		type: Object,
		default: () => [],
	},
	title: {
		type: String,
		default: "本週推薦",
	},
	schannel: {
		type: String,
		default: "calc-weekly-m",
	},
});

const weeklyRecommendGroups = computed(() => {
	const list = Array.isArray(props.data) ? props.data.slice(0, 6) : [];

	return list.reduce((groups, item, index) => {
		const groupIndex = Math.floor(index / 3);
		groups[groupIndex] ||= [];
		groups[groupIndex].push(item);
		return groups;
	}, []);
});

const toWeeklyRecommend = url => {
	logEvent("home_Weekly_click");
	goLink(url, props.schannel);
};
</script>

<style lang="scss" scoped>
.weekly-recommend {
	margin-top: 48px;
	width: 686px;

	&__title {
		margin: 0 0 16px;
		font-weight: 600;
		font-size: 36px;
		line-height: 60px;
		color: #333333;
	}

	&__groups {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	&__group {
		padding: 16px 32px;
		background: #ffffff;
		border: 1px solid #efefef;
		border-radius: 11px;
	}

	&__item {
		cursor: pointer;
	}

	&__item--cover {
		margin-bottom: 8px;
	}

	&__item--text {
		height: 80px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #efefef;

		&:last-child {
			border-bottom: none;
		}
	}

	&__cover {
		width: 622px;
		height: 197px;
		overflow: hidden;
		border-radius: 10px;
		object-fit: cover;
	}

	&__name {
		min-width: 0;
		font-weight: 400;
		font-size: 28px;
		line-height: 36px;
		color: #1f2329;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__arrow {
		margin-left: auto;
		font-size: 32px;
		line-height: 32px;
		color: #8b8b8b;
	}
}
</style>
